"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBettingSessionStatus = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useQuery_1 = require("../useQuery");
var useBettingSessionStatus = function (_a) {
    var successAction = _a.successAction;
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.BETTING_SESSION_STATUS,
        successAction: function (data) {
            successAction === null || successAction === void 0 ? void 0 : successAction(data);
        },
        refreshInterval: 1000,
    }), isValidating = _b.isValidating, isLoading = _b.isLoading, error = _b.error, data = _b.data;
    return (0, react_1.useMemo)(function () { return ({
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
        data: data === null || data === void 0 ? void 0 : data.data,
    }); }, [isLoading, isValidating, error, data]);
};
exports.useBettingSessionStatus = useBettingSessionStatus;
